import { IDocumentTokenDto } from "@/models/document-token.entity";
import { SignatureImageTokenConfig } from "@/lib/signature-token.utils";
import { VuetifyMaterialColorEnum } from "@/lib/enum/vuetify-color.enum";
import { BaseTokenEntity } from "./base-token.entity";

export class ImageSignatureTokenEntity extends BaseTokenEntity {
  static readonly token = "{{sign.img}}";

  get tokenString() {
    return ImageSignatureTokenEntity.token;
  }

  get colorHex() {
    return VuetifyMaterialColorEnum.BLUE_GREY_DARKEN_1;
  }

  get icon() {
    return "mdi-signature-freehand";
  }

  get color() {
    return "blue-grey darken-1";
  }

  get labelKey() {
    return "sign.fieldType.signatureImg";
  }

  get defaultSize() {
    return { w: 0.2, h: 0.09 };
  }

  get fixedSize() {
    return true;
  }

  validateConstraints(pageWidthMm?: number, pageHeightMm?: number) {
    const width = pageWidthMm ? SignatureImageTokenConfig.w / pageWidthMm : this.defaultSize.w;
    const height = pageHeightMm ? SignatureImageTokenConfig.h / pageHeightMm : this.defaultSize.h;
    this.centerBounds(width, height);
  }

  toDto(widthPx: number, heightPx: number): IDocumentTokenDto {
    return this.buildDto(widthPx, heightPx);
  }
}
